// This is a hacky type to cater for all the state that is currently untyped. We

import { Pricing } from '../types';

// don't want to keep this
type UnknownUiState = Record<string, any>;

export interface UI {
  tiersPricing: {
    free: Pricing;
    plus: Pricing;
    pro_2022: Pricing;
    premium_2022: Pricing;
  };

  payment: {
    activeMethod: string;
  } & UnknownUiState;
  uploader: {
    options: {
      visible: boolean;
    };
  };
  showConsentWallPreferences: false;
  seatsPricing?: UnknownUiState;
}

export default {
  tiersPricing: null,
  payment: {
    activeMethod: '',
  },
  uploader: {
    options: {
      visible: false,
    },
  },
  showConsentWallPreferences: false,
} as UI;
